import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import TestsWidget from "../test/TestsWidget";
import NotificationWidget from "../notification/NotificationWidget";
import Auth from "../auth/Auth";
import { getUser } from "../auth/Auth";
import { translate } from "../base/Translation";

export default class Home extends Auth {

	renderNotifications() {
		if (getUser().role >= 6) {
			return (
				<div className="col-lg-4">
					<div id="js-users-wrapper"><NotificationWidget /></div>
				</div>
			)
		}
		return false;
	}

	renderTests() {
		return (
			<div className="col-lg-4">
				<div id="js-tests-wrapper"><TestsWidget /></div>
			</div>
		)
	}

	render() {
		return (
			<Page>
				<PageHeader title={translate("Hlavný panel")} />
				<PageBody>
					<div className="row">
						{this.renderNotifications()}
						{this.renderTests()}
					</div>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/home/Home.js